import { render, staticRenderFns } from "./ManualDataListItem.vue?vue&type=template&id=6d6586a8"
import script from "./ManualDataListItem.vue?vue&type=script&lang=js"
export * from "./ManualDataListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports